import { authApi } from './client';

const ACCEPT_JSON = { 'Accept': 'application/json' };
const JSON_HEADERS = { 'Content-Type': 'application/json' };

export const listWorkshops = () =>
    authApi.get('/list-talleres/', { headers: ACCEPT_JSON });

export const createWorkshop = ({ nombre, descripcion, fechaInicio }) =>
    authApi.post('/create-taller/', JSON.stringify({ nombre, descripcion, fechaInicio }), { headers: JSON_HEADERS });

export const updateWorkshop = ({ id, nombre, descripcion, fechaInicio }) =>
    authApi.put('/update-taller/', JSON.stringify({ id, nombre, descripcion, fechaInicio }), { headers: JSON_HEADERS });

export const deleteWorkshop = id =>
    authApi.delete('/delete-taller/', { headers: ACCEPT_JSON, data: { id } });
